module.exports = __webpack_public_path__ + "img/f21.f5e0410d.png";